<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch"></com-search>
    <com-card>
      <com-table ref="table" :columns="columns" :api="api">
        <template #operation="row">
          <el-button type="primary" size="mini" @click="handleEdit(row.data)">详情</el-button>
        </template>
        <template #createTime="row">
          {{ row.data.createTime | timeFormate }}
        </template>
        <template #description="row">
          <div class="overflow-2">
            {{ row.data.description }}
          </div>
        </template>
      </com-table>
    </com-card>
    <the-feedback-details ref="detail"></the-feedback-details>
  </com-page>
</template>

<script>
import { userFeedback } from '@/api/feedback'

import theFeedbackDetails from './components/the-feedback-details'

export default {
  components: { theFeedbackDetails },
  data() {
    return {
      api: userFeedback,
      searchColumns: [
        {
          label: '用户ID',
          prop: 'number',
          type: 'input'
        },
        {
          label: '联系方式',
          prop: 'phone',
          type: 'input'
        },
        {
          label: '问题类型',
          prop: 'type',
          type: 'select',
          option: []
        }
      ],
      columns: [
        {
          label: '用户ID',
          prop: 'number'
        },
        {
          label: '联系方式',
          prop: 'phone'
        },
        {
          label: '问题类型',
          prop: 'type'
        },
        {
          label: '问题过程',
          prop: 'description',
          type: 'slot',
          slotName: 'description',
          width: 180
        },
        {
          label: '反馈时间',
          prop: 'createTime',
          type: 'slot',
          slotName: 'createTime',
          width: 180
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation'
        }
      ]
    }
  },
  methods: {
    handleEdit(row) {
      const params = {
        ...row,
        viewType: 'feedBack'
      }
      this.$refs.detail.open(params)
    },
    handleCreated() {},
    handleSearch(val) {
      this.$refs.table.search(val)
    }
  }
}
</script>
